import { z } from 'zod';

import { InstanceIdType } from '#core/schema/defs';
import { CogniteAssetModel } from '#core/schema/model/cdm/CogniteAssetModel';

import { WellStringModel } from '#schema/model/WellStringModel';

export const ReservoirModel = z
  .object({
    ...CogniteAssetModel.shape,

    children: WellStringModel.array().optional().default([]),

    reservoirBicarbonateConcentration: z
      .number()
      .optional()
      .describe('Bicarbonate concentration in the reservoirs formation water (mg/L).'),
    reservoirBottomHolePressure: z.number().optional().describe('Bottomhole pressure of the reservoir (psi).'),
    reservoirBottomholeTemperature: z
      .number()
      .optional()
      .describe('Bottomhole temperature of the reservoir (Fahrenheit).'),
    reservoirCalciumConcentration: z
      .number()
      .optional()
      .describe('Calcium concentration in the reservoirs formation water (mg/L).'),
    reservoirChemistryModel: InstanceIdType.optional().describe(
      'Reservoir chemistry model, used for predicting formation water chemistry.',
    ),
    reservoirChlorideConcentration: z
      .number()
      .optional()
      .describe('Chloride concentration in the reservoirs formation water (mg/L).'),
    reservoirHydroBlendModel: InstanceIdType.optional().describe(
      'HydroBlend model for the reservoir, used for predicting seawater percentage.',
    ),
    reservoirMagnesiumConcentration: z
      .number()
      .optional()
      .describe('Magnesium concentration in the reservoirs formation water (mg/L).'),
    reservoirPH: z.number().optional().describe('pH of the reservoirs formation water.'),
    reservoirScaleIndexModel: InstanceIdType.optional().describe(
      'Scale index model for the reservoir, used for predicting Scale Index.',
    ),
    reservoirSodiumConcentration: z
      .number()
      .optional()
      .describe('Sodium concentration in the reservoirs formation water (mg/L).'),
    reservoirSpecificGravity: z.number().optional().describe('Specific gravity of the reservoirs formation water.'),
    reservoirStrontiumConcentration: z
      .number()
      .optional()
      .describe('Strontium concentration in the reservoirs formation water (mg/L).'),
    reservoirSulphateConcentration: z
      .number()
      .optional()
      .describe('Sulphate concentration in the reservoirs formation water (mg/L).'),
    reservoirTotalDissolvedSolids: z
      .number()
      .optional()
      .describe('Total dissolved solids in the reservoirs formation water (mg/L).'),
  })
  .describe('Reservoir asset, representing a collection of wells.');

export type ReservoirModelInput = z.input<typeof ReservoirModel>;
export type ReservoirModelOutput = z.output<typeof ReservoirModel>;
